/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Api_Key_Dialog_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add a new API key for your organization. The key will be validated after creation." |
*
* @param {Create_Api_Key_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_api_key_dialog_description = /** @type {((inputs?: Create_Api_Key_Dialog_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Api_Key_Dialog_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie Ihrer Organisation einen neuen API-Schlüssel hinzu. Der Schlüssel wird nach der Erstellung validiert.")
	return /** @type {LocalizedString} */ ("Add a new API key for your organization. The key will be validated after creation.")
});